import React, { useEffect, useState } from "react";
import "./css/styles.css";
import Slider from "react-slick";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import {
  BsFillArrowLeftSquareFill,
  BsFillArrowRightSquareFill,
} from "react-icons/bs";

const faqBanner = require("./images/course-bg-banner.png");

const book = require("./images/book.png");

const countryUniversitiesContent = [
  {
    countryName: "GERMANY",
    countryShort: "Germany",
    overview:
      "An International Degree Course is a type of course that covers undergraduate",
    topUniversities: [
      {
        universityImg: require("../../assets/university/germany1/Technische-Universitat-Munchen1.jpg"),
        universityNo: "50",
        universityName: "Technical University of Munich",
        universityTitle: "Oxford",
        universityInfo: `The Technical University of Munich is a public research university in Munich, with additional campuses in Garching, Freising, Heilbronn, Straubing, and Singapore.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Ludwig-Maximilians-Universitat-Munchen1.jpg"),
        universityNo: "63",
        universityName: "Ruprecht-Karls-Universität Heidelberg",
        universityTitle: "Oxford",
        universityInfo: `Ludwig Maximilian University of Munich is a public research university located in Munich, Germany. The University of Munich is Germany's sixth-oldest university in continuous operation.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Ruperacht-Karls-Universitat-Heidelberg1.jpg"),
        universityNo: "64",
        universityName: "Ludwig-Maximilians-Universität München",
        universityTitle: "Oxford",
        universityInfo: `Heidelberg University, officially the Ruprecht Karl University of Heidelberg, is a public research university in Heidelberg, Baden-Württemberg, Germany. Founded in 1386 on instruction of Pope Urban VI, Heidelberg is Germany's oldest university and one of the world's oldest surviving universities.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Humboldt-Universitat-zu-Berlin1.jpg"),
        universityNo: "127",
        universityName: "Freie Universitaet Berlin",
        universityTitle: "Oxford",
        universityInfo: `Humboldt University of Berlin  is a public research university in the central borough of Mitte in Berlin, Germany. It was established by Frederick William III on the initiative of Wilhelm von Humboldt, Johann Gottlieb Fichte and Friedrich Ernst Daniel Schleiermacher as the University of Berlin (Universität zu Berlin) in 1809, and opened in 1810, making it the oldest of Berlin's four universities.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Freie-University-of-Berlin1.jpg"),
        universityNo: "128",
        universityName: "Humboldt-Universität zu Berlin",
        universityTitle: "Oxford",
        universityInfo: `Freie Universität Berlin has been one of the German universities of excellence since 2007. The university is leading in research and teaching and has many regional and international partners. Facts and Figures. Cooperation. Founding History.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Karlsruher_Institut_of_Technologie1.jpg"),
        universityNo: "138",
        universityName: "Karlsruher Institut fur Technologie",
        universityTitle: "Oxford",
        universityInfo: `The Karlsruhe Institute of Technology is an elite public research university in the German state Baden-Württemberg and a national research center in the Helmholtz Association that is one of the largest educational institutions and the largest research institution by funding in Germany.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Rheinisch-Westfalische-Technische-Hochschule-Aachen1.jpg"),
        universityNo: "159",
        universityName: "KIT, Karlsruhe Institute of Technology",
        universityTitle: "Oxford",
        universityInfo: `RWTH Aachen University or Rheinisch-Westfälische Technische Hochschule Aachen is an elite German public research university located in Aachen, North Rhine-Westphalia, Germany. With more than 47,000 students enrolled in 144 study programs, it is the largest technical university in Germany.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Technische-Universitat-Berlin1.jpg"),
        universityNo: "165",
        universityName: "Technische Universitat Berlin",
        universityTitle: "Oxford",
        universityInfo: `The Technical University of Berlin (official name both in English and German: Technische Universität Berlin, also known as TU Berlin and Berlin Institute of Technology) is a public research university located in Berlin, Germany. It was the first German university to adopt the name "Technische Universität" (Technical University).`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Technische-Universitat-Dresden1.jpg"),
        universityNo: "172",
        universityName: "Technische Universitat Dresden",
        universityTitle: "Oxford",
        universityInfo: `TU Dresden (for German: Technische Universität Dresden, abbreviated as TUD and often wrongly translated as "Dresden University of Technology") is a public research university, the largest institute of higher education in the city of Dresden, the largest university in Saxony and one of the 10 largest universities in germany`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/germany1/Eberhard-Karls-Universitat-Tubingan1.jpg"),
        universityNo: "177",
        universityName: "Eberhard Karls Universitat Tubingan",
        universityTitle: "Oxford",
        universityInfo: `The University of Tübingen, officially the Eberhard Karl University of Tübingen, is a public research university located in the city of Tübingen, Baden-Württemberg, Germany. The University of Tübingen is one of eleven German Excellence Universities.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
    ],
    courses: [
      "Computer Science Engineering",
      "Chemical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Mechanical Engineering",
    ],
  },
  {
    countryName: "U.S.A.",
    countryShort: "U.S.A.",
    overview: "",
    topUniversities: [
      {
        universityImg: require("../../assets/university/usa/Massachusetts-Institute-of-Technology1.jpg"),
        universityNo: "01",
        universityName: "Massachusetts Institute of Technology",
        universityTitle: "Oxford",
        universityInfo: `Massachusetts Institute of Technology is a private land-grant research university in Cambridge, Massachusetts. Established in 1861, MIT has since played a key role in the development of modern technology and science, ranking it among the top academic institutions in the world.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/Stanford-University1.jpg"),
        universityNo: "03",
        universityName: "Stanford University",
        universityTitle: "Oxford",
        universityInfo: `	Stanford University, officially Leland Stanford Junior University, is a private research university located in the census-designated place of Stanford, California, near the city of Palo Alto. The campus occupies 8,180 acres, among the largest in the United States, and enrolls over 17,000 students.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/Cornell-University1.jpg"),
        universityNo: "05",
        universityName: "Cornell University",
        universityTitle: "Oxford",
        universityInfo: `Cornell University is a private Ivy League and statutory land-grant research university, based in Ithaca, New York. Founded in 1865 by Ezra Cornell and Andrew Dickson White, Cornell was founded with the intention to teach and make contributions in all fields of knowledge — from the classics to the sciences, and from the theoretical to the applied. These ideals, unconventional for the time, are captured in Cornell's founding principle, a popular 1868 quotation from founder Ezra Cornell: "I would found an institution where any person can find instruction in any study.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/Harvard-University1.jpg"),
        universityNo: "06",
        universityName: "Harvard University",
        universityTitle: "Oxford",
        universityInfo: `Harvard University is a private Ivy League research university in Cambridge, Massachusetts. Founded in 1636 as Harvard College and named for its first benefactor, the Puritan clergyman John Harvard, it is the oldest institution of higher learning in the United States and among the most prestigious in the world.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/California-Institute-of-Technology1.jpg"),
        universityNo: "10",
        universityName: "California Institute of Technology",
        universityTitle: "Oxford",
        universityInfo: `The California Institute of Technology is a private research university in Pasadena, California. The university is known for its strength in science and engineering, and is among a small group of institutes of technology in the United States which is primarily devoted to the instruction of pure and applied sciences.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/University-of-Chicago1.jpg"),
        universityNo: "13",
        universityName: "University of Chicago",
        universityTitle: "Oxford",
        universityInfo: `The University of Chicago (UChicago) is a private research university in Chicago, Illinois. Founded in 1890, its main campus is located in Chicago's Hyde Park neighborhood. The University of Chicago is consistently ranked among the best universities in the world and it is among the most selective in the United States`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/University-of-Pennsylvania1.jpg"),
        universityNo: "14",
        universityName: "University of Pennsylvania",
        universityTitle: "Oxford",
        universityInfo: `The University of Pennsylvania is a private Ivy League research university in Philadelphia, Pennsylvania. The university, established as the College of Philadelphia in 1740, is one of the nine colonial colleges chartered before the U.S. Declaration of Independence.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/University-of-yale1.jpg"),
        universityNo: "19",
        universityName: "Yale University",
        universityTitle: "Oxford",
        universityInfo: `Yale University is a private Ivy League research university in New Haven, Connecticut. Founded in 1701 as the Collegiate School, it is the third-oldest institution of higher education in the United States and among the most prestigious in the world.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/Columbia-University1.jpg"),
        universityNo: "20",
        universityName: "Columbia University",
        universityTitle: "Oxford",
        universityInfo: `Columbia University (also known as Columbia, and officially as Columbia University in the City of New York) is a private Ivy League research university in New York City. Established in 1754 as King's College on the grounds of Trinity Church in Manhattan, Columbia is the oldest institution of higher education in New York and the fifth-oldest institution of higher learning in the United States. It is one of nine colonial colleges founded prior to the Declaration of Independence, seven of which belong to the Ivy League. Columbia is ranked among the most prestigious academic institutions in the world`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/usa/Princeton-University1.jpg"),
        universityNo: "21",
        universityName: "Princeton University",
        universityTitle: "Oxford",
        universityInfo: `Princeton University is a private Ivy League research university in Princeton, New Jersey. Founded in 1746 in Elizabeth as the College of New Jersey, Princeton is the fourth-oldest institution of higher education in the United States and one of the nine colonial colleges chartered before the American Revolution.The institution moved to Newark in 1747, and then to the current site nine years later. It officially became a university in 1896 and was subsequently renamed Princeton University. Princeton is often ranked among the best and most prestigious universities in the world`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
    ],
    courses: [
      "Business Management",
      "Engineering",
      "Maths and Computer Sciences",
      "Social Sciences",
      "Physical and Life Sciences",
    ],
  },
  {
    countryName: "UNITED KINGDOM",
    countryShort: "UK",
    overview:
      "Types of Scholarships available for international students in the United Kingdom",
    topUniversities: [
      {
        universityImg: require("../../assets/university/uk1/University-of-Oxford1.jpg"),
        universityNo: "02",
        universityName: "University of Oxford",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Oxford is a collegiate research university in Oxford, England. There is evidence of teaching as early as 1096, making it the oldest university in the English-speaking world and the world's second-oldest university in continuous operation.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/University-of-Cambridge1.jpg"),
        universityNo: "03",
        universityName: "University of Cambridge",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Cambridge is a collegiate research university in Cambridge, United Kingdom. Founded in 1209 and granted a royal charter by Henry III in 1231, Cambridge is the second-oldest university in the English-speaking world and the world's third-oldest surviving university. ",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/Imperial-College-London1.jpg"),
        universityNo: "07",
        universityName: "Imperial College London",
        universityTitle: "Oxford",
        universityInfo:
          "Imperial College London, legally the Imperial College of Science, Technology and Medicine, is a public research university in London. Imperial grew out of Prince Albert's vision for an area of culture, including the Royal Albert Hall, Victoria & Albert Museum, Natural History Museum, and several Royal Colleges.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/UCL1.jpg"),
        universityNo: "08",
        universityName: "UCL",
        universityTitle: "Oxford",
        universityInfo:
          "University College London, which operates as UCL, is a major public research university located in London, United Kingdom. UCL is a member institution of the federal University of London, and is the second-largest university in the United Kingdom by total enrolment and the largest by postgraduate enrolment.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/The-University-of-Edinburgh1.jpg"),
        universityNo: "16",
        universityName: "The University of Edinburgh",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Edinburgh is a public research university in Edinburgh, Scotland. Granted a royal charter by King James VI in 1582 and officially opened in 1583, it is one of Scotland's four ancient universities and the sixth-oldest university in continuous operation in the English-speaking world. ",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/The-University-of-Manchester1.jpg"),
        universityNo: "27",
        universityName: "The University of Manchester",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Manchester is a public research university in Manchester, England. The main campus is south of Manchester City Centre on Oxford Road.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/King's-College-London1.jpg"),
        universityNo: "35",
        universityName: "King's College London",
        universityTitle: "Oxford",
        universityInfo:
          "King's College London is a public research university located in London, England. King's was established by royal charter in 1829 under the patronage of King George IV and the Duke of Wellington. In 1836, King's became one of the two founding colleges of the University of London. ",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/The-London-School-of-Economics-and-Political-Science1.jpg"),
        universityNo: "49",
        universityName: "The London School of Economics and Political Science",
        universityTitle: "Oxford",
        universityInfo:
          "The London School of Economics and Political Science is a public research university located in London, England, and a constituent college of the federal University of London.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/The-University-of-Warwick1.jpg"),
        universityNo: "61",
        universityName: "The University of Warwick",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Warwick is a public research university on the outskirts of Coventry between the West Midlands and Warwickshire, England. The university was founded in 1965 as part of a government initiative to expand higher education. ",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/uk1/University-of-Bristol1.jpg"),
        universityNo: "62",
        universityName: "University of Bristol",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Bristol is a red brick Russell Group research university in Bristol, England. It received its royal charter in 1909, although it can trace its roots to a Merchant Venturers' school founded in 1595 and University College, Bristol, which had been in existence since 1876.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
    ],
    courses: [
      "Business",
      "Natural Sciences",
      "Engineering and Technology",
      "Medicine",
      "Law	",
      "Social Sciences	",
      "Sports Sciences	",
      "Media and Communication	",
      "Arts	",
      "Hospitality and Tourism	",
    ],
  },
  {
    countryName: "CANADA",
    countryShort: "Canada",
    overview:
      "There are three types of scholarships available for study abroad Canada",
    topUniversities: [
      {
        universityImg: require("../../assets/university/CANADA1/University-of-Toronto1.jpg"),
        universityNo: "26",
        universityName: "University of Toronto",
        universityTitle: "Oxford",
        universityInfo: `The University of Toronto is a public research university in Toronto, Ontario, Canada, located on the grounds that surround Queen's Park. It was founded by royal charter in 1827 as King's College, the first institution of higher learning in Upper Canada.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/McGill-University1.jpg"),
        universityNo: "27",
        universityName: "McGill University",
        universityTitle: "Oxford",
        universityInfo: `McGill University is an English-language public research university located in Montreal, Quebec, Canada.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/University-of-British-Columbia1.jpg"),
        universityNo: "46",
        universityName: "University of British Columbia",
        universityTitle: "Oxford",
        universityInfo: `The University of British Columbia is a public research university with campuses near Vancouver and in Kelowna, British Columbia. Established in 1908, it is British Columbia's oldest university. The university ranks among the top three universities in Canada.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/University-of-MONTREAL1.jpg"),
        universityNo: "111",
        universityName: "University of Montreal",
        universityTitle: "Oxford",
        universityInfo: `The Université de Montréal is a French-language public research university in Montreal, Quebec, Canada. The university's main campus is located in the Côte-des-Neiges neighborhood of Côte-des-Neiges–Notre-Dame-de-Grâce on Mount Royal near the Outremont Summit, in the borough of Outremont. `,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/University-of-Alberta1.jpg"),
        universityNo: "126",
        universityName: "University of Alberta",
        universityTitle: "Oxford",
        universityInfo: `The University of Alberta, also known as U of A or UAlberta, is a public research university located in Edmonton, Alberta, Canada. It was founded in 1908 by Alexander Cameron Rutherford, the first premier of Alberta, and Henry Marshall Tory, the university's first president.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/McMaster-University1.jpg"),
        universityNo: "140",
        universityName: "McMaster University",
        universityTitle: "Oxford",
        universityInfo: `McMaster University is a public research university in Hamilton, Ontario, Canada. The main McMaster campus is on 121 hectares of land near the residential neighbourhoods of Ainslie Wood and Westdale, adjacent to the Royal Botanical Gardens. `,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/University-of-Waterloo1.jpg"),
        universityNo: "149",
        universityName: "University of Waterloo",
        universityTitle: "Oxford",
        universityInfo: `The University of Waterloo is a public research university with a main campus in Waterloo, Ontario, Canada. The main campus is on 404 hectares of land adjacent to "Uptown" Waterloo and Waterloo Park. The university also operates three satellite campuses and four affiliated university colleges.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/Western-University1.jpg"),
        universityNo: "170",
        universityName: "Western University",
        universityTitle: "Oxford",
        universityInfo: `The University of Western Ontario is a public research university in London, Ontario, Canada. The main campus is located on 455 hectares of land, surrounded by residential neighbourhoods and the Thames River bisecting the campus's eastern portion. The university operates twelve academic faculties and schools.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/Queen's-University1.jpg"),
        universityNo: "230",
        universityName: "Queen's University",
        universityTitle: "Oxford",
        universityInfo: `Queen's University at Kingston, commonly known as Queen's University or simply Queen's, is a public research university in Kingston, Ontario, Canada. Queen's holds more than 1,400 hectares (3,500 acres) of land throughout Ontario and owns Herstmonceux Castle in East Sussex, England.Queen's is organized into eight faculties and schools.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/CANADA1/University-of-Calgary1.jpg"),
        universityNo: "235",
        universityName: "University of Calgary",
        universityTitle: "Oxford",
        universityInfo: `The University of Calgary (U of C or UCalgary) is a public research university located in Calgary, Alberta, Canada. The University of Calgary started in 1944 as the Calgary branch of the University of Alberta, founded in 1908, prior to being instituted into a separate, autonomous university in 1966. It is composed of 14 faculties and over 85 research institutes and centres.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
    ],
    courses: [
      "MBA",
      "Computer Science and IT",
      "Business and Finance",
      "Core Engineering and Engineering Management",
      "Physical and Earth Sciences and Renewable Energy",
      "Agricultural Science and Forestry",
      "Biosciences, Medicine and Healthcare",
      "Media & Journalism",
      "Mathematics, Statistics, Actuarial Science & Analytics",
      "Psychology & Human Resources",
    ],
  },
  {
    countryName: "U.A.E",
    countryShort: "U.A.E",
    overview:
      "In U.A.E, you can study on fully or partially funded scholarships. Every year, the government of U.A.E and universities in U.A.E award scholarships to international students and local residents, here is a compiled list of some of the best PhD Scholarships in U.A.E, Masters Scholarships in U.A.E, and undergraduate level scholarships.",
    topUniversities: [
      {
        universityImg: require("../../assets/university/DUBAI1/United-Arab-Emirates-University1.jpg"),
        universityNo: "183",
        universityName: "United Arab Emirates University",
        universityTitle: "Oxford",
        universityInfo: `United Arab Emirates University is a public research university located in Al Ain, United Arab Emirates. It is the oldest university in the United Arab Emirates. It was established in 1976 after independence from Britain by the founding father of the UAE, the late Sheikh Zayed bin Sultan Al Nahyan.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/DUBAI1/Khalifa-University1.jpg"),
        universityNo: "288",
        universityName: "Khalifa University",
        universityTitle: "Oxford",
        universityInfo: `Khalifa University is a public research university located in Abu Dhabi, United Arab Emirates, with a satellite campus in Sharjah. It was ranked as the 183rd best university in the world by QS world university rankings of 2022.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/DUBAI1/University-of-Sharjah1.jpg"),
        universityNo: "601",
        universityName: "University of Sharjah",
        universityTitle: "Oxford",
        universityInfo: `The University of Sharjah is an Emirati private national university located in University City, Sharjah, United Arab Emirates. It was established in October 1997 by its founder the ruler of Sharjah Sheikh Dr. Sultan bin Muhammad Al-Qasimi to meet the emirate of Sharjah's aim of educational needs.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/DUBAI1/American-University-of-Sharjah1.jpg"),
        universityNo: "651",
        universityName: "American University of Sharjah (AUS)",
        universityTitle: "Oxford",
        universityInfo: `American University of Sharjah is a private university in the United Arab Emirates. It was founded in 1997 by His Highness Sheikh Dr. Sultan bin Muhammad Al-Qasimi, Supreme Council Member and Ruler of Sharjah. Sheikh Dr. Sultan envisaged the university as a leading educational institution in the Persian Gulf region.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/DUBAI1/Zayed-University1.jpg"),
        universityNo: "383",
        universityName: "Zayed University",
        universityTitle: "Oxford",
        universityInfo: `Zayed University is a public university based in the United Arab Emirates. It was established in 1998. It is one of the three government-sponsored higher education institutions in the United Arab Emirates. It is named in honor of Sheikh Zayed bin Sultan Al Nahyan, the country's first president.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/DUBAI1/American-University-in-Dubai1.jpg"),
        universityNo: "601",
        universityName: "American University in Dubai",
        universityTitle: "Oxford",
        universityInfo: `The American University in Dubai is a private, non-sectarian institution of higher learning in U.A.E, United Arab Emirates, founded in 1995. AUD is accredited regionally as a separate unit by the Southern Association of Colleges and Schools.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/DUBAI1/Abu-Dhabi-University1.jpg"),
        universityNo: "701",
        universityName: "Abu Dhabi University",
        universityTitle: "Oxford",
        universityInfo: `Abu Dhabi University is a university in the United Arab Emirates with campuses in Abu Dhabi, Al Ain and Dubai. It was established in 2003, after three years of planning by Hamdan Bin Zayed Al Nahyan and other citizens of the United Arab Emirates`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/DUBAI1/Ajman-University1.jpg"),
        universityNo: "701",
        universityName: "Ajman University",
        universityTitle: "Oxford",
        universityInfo: `Ajman University (Arabic: جامعة عجمان) was established in 17 June 1988 as the first private university in the GCC, Ajman University (AU) also was the first university in the UAE to admit expatriate students under the institutional name "Ajman University College of Science and Technology" and subsequently was renamed "Ajman University of Science and Technology". In 2018, it was renamed again to "Ajman University".`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
    ],
    courses: [
      "International Hospitality Management",
      "Aerospace Engineering",
      "Civil Engineering/Construction Management",
      "Business Administration/MBA",
      "Accounts and Finance",
      "Medicine",
      "Aviation",
      "Design Studies",
      "Architecture",
    ],
  },
  {
    countryName: "AUSTRALIA",
    countryShort: "Australia",
    overview:
      "There is a vast variety of scholarships available for international students.",
    topUniversities: [
      {
        universityImg: require("../../assets/university/AUS1/Australian-National-University1.jpg"),
        universityNo: "27",
        universityName: "Australian National University",
        universityTitle: "Oxford",
        universityInfo:
          "The Australian National University is a public research university located in Canberra, the capital of Australia. Its main campus in Acton encompasses seven teaching and research colleges, in addition to several national academies and institutes.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/University-of-Melbourne1.jpg"),
        universityNo: "37",
        universityName: "University of Melbourne",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Melbourne is a public research university located in Melbourne, Australia. Founded in 1853, it is Australia's second oldest university and the oldest in Victoria.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/University-of-Sydney1.jpg"),
        universityNo: "38",
        universityName: "University of Sydney",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Sydney is a public research university located in Sydney, Australia. Founded in 1850 as Australia's first university, it is regarded as one of the world's leading universities. The university is one of Australia's six sandstone universities",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/University-of-New-South-Wales1.jpg"),
        universityNo: "43",
        universityName: "University of New South Wales",
        universityTitle: "Oxford",
        universityInfo:
          "The University of New South Wales, also known as UNSW Sydney, is a public research university based in Sydney, New South Wales, Australia. It is one of the founding members of Group of Eight, a coalition of Australian research-intensive universities.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/University-of-Queensland1.jpg"),
        universityNo: "47",
        universityName: "University of Queensland",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Queensland is a public research university located primarily in Brisbane, the capital city of the Australian state of Queensland. Founded in 1909 by the Queensland parliament, UQ is one of the six sandstone universities, an informal designation of the oldest university in each state.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/Monash-University1.jpg"),
        universityNo: "58",
        universityName: "Monash University",
        universityTitle: "Oxford",
        universityInfo:
          "Monash University is a public research university based in Melbourne, Victoria, Australia. Named for prominent World War I general Sir John Monash, it was founded in 1958 and is the second oldest university in the state. The university has a number of campuses, four of which are in Victoria, and one in Malaysia.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/University-of-Western-Australia1.jpg"),
        universityNo: "93",
        universityName: "University of Western Australia",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Western Australia is a public research university in the Australian state of Western Australia. The university's main campus is in Perth, the state capital, with a secondary campus in Albany and various other facilities elsewhere.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/University-of-Adelaide1.jpg"),
        universityNo: "108",
        universityName: "University of Adelaide",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Adelaide is a public research university located in Adelaide, South Australia. Established in 1874, it is the third-oldest university in Australia.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/Monash-University1.jpg"),
        universityNo: "133",
        universityName: "MohUniversity of Technology Sydneyawk",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Technology Sydney is a public research university located in Sydney, Australia. Although its origins are said to trace back to the 1870s, the university was founded in its current form in 1988. As of 2021, UTS enrols 45,221 students through its 9 faculties and schools.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("../../assets/university/AUS1/University-of-Wollongong1.jpg"),
        universityNo: "193",
        universityName: "University of Wollongong",
        universityTitle: "Oxford",
        universityInfo:
          "The University of Wollongong is an Australian public research university located in the coastal city of Wollongong, New South Wales, approximately 80 kilometres south of Sydney. As of 2017, the university had an enrolment of more than 32,000 students, an alumni base of more than 131,859 and over 2,400 staff members.",
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
    ],
    courses: [
      "Accountancy",
      "Actuarial Science",
      " Agriculture Sciences",
      " Architecture",
      "Biomedical Engineering",
      " Core Engineering",
      "Earth Sciences",
      " Computer Science and Information Technology",
      "Psychology",
      " Tourism and Hospitality Management",
    ],
  },
];

export default function TopUniversity(props) {
  const customSlider = React.useRef();
  const [selectedCountryInfo, setSelectedCountryInfo] = useState({
    countryName: "GERMANY",
    countryShort: "Germany",
    overview:
      "An International Degree Course is a type of course that covers undergraduate",
    topUniversities: [
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "01",
        universityName: "Technische Universitat Munchen",
        universityTitle: "Oxford",
        universityInfo: `The Technical University of Munich is a public research university in Munich, with additional campuses in Garching, Freising, Heilbronn, Straubing, and Singapore.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "02",
        universityName: "Ludwig-Maximilians-Universitat Munchen",
        universityTitle: "Oxford",
        universityInfo: `Ludwig Maximilian University of Munich is a public research university located in Munich, Germany. The University of Munich is Germany's sixth-oldest university in continuous operation.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "03",
        universityName: "Ruperacht-Karls-Universitat Heidelberg",
        universityTitle: "Oxford",
        universityInfo: `Heidelberg University, officially the Ruprecht Karl University of Heidelberg, is a public research university in Heidelberg, Baden-Württemberg, Germany. Founded in 1386 on instruction of Pope Urban VI, Heidelberg is Germany's oldest university and one of the world's oldest surviving universities.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "04",
        universityName: "Humboldt-Universitat zu Berlin",
        universityTitle: "Oxford",
        universityInfo: `Humboldt University of Berlin  is a public research university in the central borough of Mitte in Berlin, Germany. It was established by Frederick William III on the initiative of Wilhelm von Humboldt, Johann Gottlieb Fichte and Friedrich Ernst Daniel Schleiermacher as the University of Berlin (Universität zu Berlin) in 1809, and opened in 1810, making it the oldest of Berlin's four universities.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "05",
        universityName: "Freie Universitat Berlin",
        universityTitle: "Oxford",
        universityInfo: `Freie Universität Berlin has been one of the German universities of excellence since 2007. The university is leading in research and teaching and has many regional and international partners. Facts and Figures. Cooperation. Founding History.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "06",
        universityName: "Karlsruher Institut fur Technologie",
        universityTitle: "Oxford",
        universityInfo: `The Karlsruhe Institute of Technology is an elite public research university in the German state Baden-Württemberg and a national research center in the Helmholtz Association that is one of the largest educational institutions and the largest research institution by funding in Germany.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "07",
        universityName: "Rheinisch-Westfalische Technische Hochschule Aachen",
        universityTitle: "Oxford",
        universityInfo: `RWTH Aachen University or Rheinisch-Westfälische Technische Hochschule Aachen is an elite German public research university located in Aachen, North Rhine-Westphalia, Germany. With more than 47,000 students enrolled in 144 study programs, it is the largest technical university in Germany.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "08",
        universityName: "Technische Universitat Berlin",
        universityTitle: "Oxford",
        universityInfo: `The Technical University of Berlin (official name both in English and German: Technische Universität Berlin, also known as TU Berlin and Berlin Institute of Technology) is a public research university located in Berlin, Germany. It was the first German university to adopt the name "Technische Universität" (Technical University).`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "09",
        universityName: "Technische Universitat Dresden",
        universityTitle: "Oxford",
        universityInfo: `TU Dresden (for German: Technische Universität Dresden, abbreviated as TUD and often wrongly translated as "Dresden University of Technology") is a public research university, the largest institute of higher education in the city of Dresden, the largest university in Saxony and one of the 10 largest universities in germany`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
      {
        universityImg: require("./images/university-image.png"),
        universityNo: "10",
        universityName: "Eberhard Karls Universitat Tubingan",
        universityTitle: "Oxford",
        universityInfo: `The University of Tübingen, officially the Eberhard Karl University of Tübingen, is a public research university located in the city of Tübingen, Baden-Württemberg, Germany. The University of Tübingen is one of eleven German Excellence Universities.`,
        className: "university-card item wow bounceIn",
        duration: "2s",
        delay: "0.5s",
      },
    ],
    courses: [],
  });

  useEffect(() => {
    if (props.selectedTab) {
      const countryInfo = countryUniversitiesContent.findIndex((info) => {
        return info.countryName === props.selectedTab;
      });

      setSelectedCountryInfo(countryUniversitiesContent[countryInfo]);
    }
  }, [props.selectedTab]);

  const renderUniversitySlider = selectedCountryInfo.topUniversities.map(
    (university, index) => {
      return (
        <div data-wow-delay={university.delay} key={Math.random()}>
          <div className="university-card item">
            <div className="university-image">
              <img src={university.universityImg} alt="university-img" />
              <div className="univ-count">{index+1}</div>
            </div>
            <div className="university-body">
              <div className="university-title">
                <p>{university.universityName} </p>
                {/* <p className="place">{university.universityTitle}</p> */}
              </div>
              <div className="uinversity-desc">
                <p>{university.universityInfo}</p>
              </div>
            </div>
            <div className="university-footer">
              <span>QS ranking</span>
              <span>{university.universityNo}</span>
            </div>
          </div>
        </div>
      );
    }
  );

  const renderCourses = selectedCountryInfo.courses.map((course) => {
    return (
      <li key={Math.random()}>
        <span className="cb-icon d-inline-block align-middle me-1">
          <img src={book} alt="book" />
        </span>
        <span className="cb-text d-inline-block align-middle">{course}</span>
      </li>
    );
  });

  const gotoNext = () => {
    customSlider.current.slickNext();
  };

  const gotoPrev = () => {
    customSlider.current.slickPrev();
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    // autoplay: true,
    initialSlide: 0,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },

      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="top-univ-wrapper">
        <div className="container-lg">
          <div className="title text-center wow bounceIn" data-wow-delay="0.5s">
            <span>
              TOP 10 UNIVERSITIES IN {selectedCountryInfo.countryName}
            </span>
          </div>
          <div className="unversity-slider-wrapper">
            <Slider {...settings} ref={customSlider}>
              {renderUniversitySlider}
            </Slider>
            <div className="btn_left_right_testimonial_container">
              <button
                className="prev_btn_testimonial same_btn_testimonial"
                onClick={() => gotoPrev()}
              >
                <BsFillArrowLeftSquareFill className="left_top_univercity_icon" />
              </button>

              <button
                className="next_btn_testimonial same_btn_testimonial"
                onClick={() => gotoNext()}
              >
                <BsFillArrowRightSquareFill className="left_top_univercity_icon" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* books  */}

      <div className="courses-wrapper res_container_books">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              <div className="row  position-relative justify-content-md-start justify-content-center">
                <div className="col-1 d-md-inline-flex d-none"></div>
                <div className=" py-5">
                  <div
                    className="courses-block container_books_container wow swing"
                    data-wow-delay="0.5s"
                    data-wow-duration="2s"
                  >
                    <div className="course-title">
                      <strong>Courses</strong>
                    </div>
                    <div className="courses-body">
                      <p className="cb-sub-title">
                        Top degrees offered by the{" "}
                        {selectedCountryInfo.countryName} universities
                      </p>
                      <ul className="list-unstyled course-list">
                        {renderCourses}
                      </ul>
                    </div>
                  </div>
                </div>
                <img
                  src={faqBanner}
                  alt="course-banner"
                  className="course-banner wow tada"
                  data-wow-delay="1s"
                  data-wow-duration="2s"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
